import http from "@/http/aisea/axios";
const resource = "/enterprises/owners";

export default {
  fetchRecordBooksByDateRange(enterpriseCrewId, params) {
    return http.get(
      `${resource}/crews/${enterpriseCrewId}/timesheets/record_books_by_date_range`,
      {
        params: params,
      }
    );
  },

  fetchRecordBooks(enterpriseManningVesselId, params) {
    return http.get(
      `${resource}/manning_vessels/${enterpriseManningVesselId}/timesheets/record_books`,
      {
        params: params,
      }
    );
  },

  downloadMonthlyRecordBook(enterpriseManningVesselId, params) {
    return http.get(
      `${resource}/manning_vessels/${enterpriseManningVesselId}/timesheets/record_books/monthly/export`,
      {
        params: params,
        responseType: "blob",
      }
    );
  },

  downloadDailyRecordBook(enterpriseManningVesselId, params) {
    return http.get(
      `${resource}/manning_vessels/${enterpriseManningVesselId}/timesheets/record_books/daily/export`,
      {
        params: params,
        responseType: "blob",
      }
    );
  },
};
